export const ENHANCEMENT_MODE = {
  OFF: 'off',
  AUTO: 'auto',
};

export type EnhancementMode =
  (typeof ENHANCEMENT_MODE)[keyof typeof ENHANCEMENT_MODE];

export const ENHANCEMENT_FILTERS = {
  BRIGHTNESS: 'filterBrightness',
  CONTRAST: 'filterContrast',
  SATURATION: 'filterSaturation',
};

export type EnhancementFilters =
  (typeof ENHANCEMENT_FILTERS)[keyof typeof ENHANCEMENT_FILTERS];
